import { Plugins, Directives } from "@frontiers-vue3/public-pages";
import { defineNuxtPlugin } from "nuxt/app";
import { useConfigurationStore } from "~/stores/configurationStore";
import { useIbarStore } from "~/stores/ibarStore";

export default defineNuxtPlugin(async (nuxtApp) => {

    nuxtApp.vueApp.use(Plugins.GoogleAnalyticsPlugin);
    nuxtApp.vueApp.use(Plugins.SanitizeHtmlPlugin);
    nuxtApp.vueApp.directive("tooltip", Directives.Tooltip);

    const configurationStore = useConfigurationStore();
    if (configurationStore.config == null) {
        await configurationStore.fetchData();
    }

    // DIF-1479 Phase 3: the Ibar depends only on `baseUrl` (config) and is independent of the
    // router middleware's user-journey calls. Kick it off now (fire-and-forget) so the request
    // runs in parallel with the middleware instead of only starting after the layout mounts.
    // The result lands in the store; the layout binds to it reactively. NOT awaited here.
    const baseUrl = configurationStore.config?.domainProperties?.defaultWebsite;
    if (baseUrl) {
        useIbarStore().load(baseUrl);
    }
});
